var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.symbol)+_vm._s(_vm._f("money")(_vm.value)))])}
var staticRenderFns = []

export { render, staticRenderFns }